import { Component, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Fatura } from 'src/app/model/fatura';
import { atLeastOneValidator } from 'src/app/shared/at-least-one.validator';
import { FaturamentoService } from 'src/app/shared/faturamento.service';
import { OverlaySpinnerService } from '../../shared/overlay-spinner.sevice';

@Component({
  selector: 'mti-buscar-faturas',
  templateUrl: './buscar-faturas.component.html',
  styleUrls: ['./buscar-faturas.component.css']
})
export class BuscarFaturasComponent implements OnDestroy {
  
  buscarForm = this.fb.group({
    competencia: [null, Validators.pattern(/^\d{4}\-\d{2}$/)],
    cliente: null,
    vencimento: null,
    liberada: null,
    faturaId: null
  },{validators: atLeastOneValidator(['competencia','cliente','vencimento','liberada','faturaId'])});

  faturas: Fatura[] = [];

  carregando = false;

  buscaSubscription!: Subscription;

  constructor(private fb: FormBuilder, private faturamentoService: FaturamentoService, private overlaySpinnerService: OverlaySpinnerService, private snackBar: MatSnackBar) {}

  ngOnDestroy(): void {
    if (this.buscaSubscription) this.buscaSubscription.unsubscribe();
  }

  onSubmit(): void {
    if (this.buscaSubscription) this.buscaSubscription.unsubscribe();

    this.carregando = true;
    this.overlaySpinnerService.showSpinner();

    this.buscaSubscription = this.faturamentoService
      .buscaFaturas(
        this.buscarForm.get('competencia')?.value,
        this.buscarForm.get('cliente')?.value,
        this.buscarForm.get('vencimento')?.value,
        this.buscarForm.get('liberada')?.value,
        this.buscarForm.get('faturaId')?.value
      )
      .subscribe(
        results => {
          this.faturas = results;
          this.carregando = false;
          this.overlaySpinnerService.stopSpinner();
        },
        (error: HttpErrorResponse) => {
          this.carregando = false;
          this.overlaySpinnerService.stopSpinner();

          const mensagem = error.error?.mensagem || error.message || 'erro desconhecido';

          const snackRef = this.snackBar.open(`erro ao buscar faturas (${error.status}): ${mensagem}`, 'fechar', {
            duration: 10 * 1000,
          });

          snackRef.onAction().subscribe(() => {
            snackRef.dismiss();
          });
        }
    );
  }
}
